import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';
import { makeTheme } from '../theme';
import '../style.css';

const theme = makeTheme('#000000');

function MainPage() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div className="content-image-container">
          <video
            controls
            className="content-item video-player"
            controlsList="nodownload"
            disablePictureInPicture
            poster={`${process.env.PUBLIC_URL}/images/2025/cover.jpg`}
          >
            <source src={`https://okhumane.sfo2.cdn.digitaloceanspaces.com/2025-yule-log.mp4`} />
            Sorry, your browser doesn't support embedded videos.
          </video>
        </div>

        <div className="content-image-container">
          <img className="content-item" alt="about yule log" src={`${process.env.PUBLIC_URL}/images/2025/collab.webp`} />
        </div>

        <div className="content-image-container">
          <a href="http://weblink.donorperfect.com/yulelog">
            <img className="content-item" alt="donate" src={`${process.env.PUBLIC_URL}/images/2025/donate.webp`} />
          </a>
        </div>

        <div className="content-image-container">
          <a href="https://youtu.be/FTGw54Z8XxA" target="_blank" rel="noopener noreferrer" >
            <img className="content-item" alt="Stream on YouTube" src={`${process.env.PUBLIC_URL}/images/2025/youtube.webp`} />
          </a>
        </div>

        <div className="content-item content-pad" style={{display: "flex", gap: '10px', justifyContent: 'center' }}>
          <img style={{ width: 'calc(50% - 20px)', height: 'auto' }} alt="yule dog" src={`${process.env.PUBLIC_URL}/images/2025/smokey-boi.jpg`} />
          <img style={{ width: 'calc(50% - 20px)', height: 'auto' }} alt="yule cat" src={`${process.env.PUBLIC_URL}/images/2025/up-kitty.jpg`} />
        </div>

        <div className="content-image-container">
          <img className="content-item" alt="track list" src={`${process.env.PUBLIC_URL}/images/2025/track-list.webp`} />
        </div>

        <div className="content-image-container">
          <a href="https://square.link/u/3wOjF8EZ" target="_blank">
            <img className="content-item content-pad" alt="firefighter calendars" src={`${process.env.PUBLIC_URL}/images/2025/calendars.webp`} />
          </a>
        </div>

        <div className="content-image-container">
          <img className="content-item" alt="firefighters" src={`${process.env.PUBLIC_URL}/images/2025/ff.webp`} />
        </div>

        <div className="content-image-container">
          <img className="content-item" alt="credits" src={`${process.env.PUBLIC_URL}/images/2025/credits.webp`} />
        </div>

        <div className="content-image-container">
          <img className="content-item" alt="sponsors" src={`${process.env.PUBLIC_URL}/images/2025/sponsors.webp`} />
        </div>

        <div className="content-image-container">
          <img className="content-item" alt="about" src={`${process.env.PUBLIC_URL}/images/2025/about.webp`} />
        </div>

        <div className="content-image-container" style={{ marginBottom: '30px' }}>
          <a href="/2024">2024 Yule Log</a>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default MainPage;
